import { render, staticRenderFns } from "./DeleteCaution.vue?vue&type=template&id=8a852224&"
import script from "./DeleteCaution.vue?vue&type=script&lang=js&"
export * from "./DeleteCaution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports